import { render, staticRenderFns } from "./LogoDemo.vue?vue&type=template&id=724e251e&scoped=true&"
import script from "./LogoDemo.vue?vue&type=script&lang=js&"
export * from "./LogoDemo.vue?vue&type=script&lang=js&"
import style0 from "./LogoDemo.vue?vue&type=style&index=0&id=724e251e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e251e",
  null
  
)

export default component.exports